import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=2813617c&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=2813617c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813617c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal.vue
// module id = 1423
// module chunks = 31